export const innova = (dataTable, catalogo) => {



    const processDenuncias = (dataTable, catalogo) => {
        const reportMap = {};

        let banner = "innovasport"


        if (dataTable.isInnova) {
            banner = dataTable.isInnova
        }

        const capitalizeWords = (str) => {
            return str
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        };

        dataTable.data[0].data[2].forEach((subArray) => {
            let tipoDenuncia = "unknown";
            let tipoBanner = "unknown";
            let catalogoEncontrado = false;

            subArray.forEach((item) => {
                if (item.key === catalogo) {
                    catalogoEncontrado = true;
                }
                if (item.key === 'C::OWN::innline_2025')
                    tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];

                if (item.key === 'C::EG::RD-102101') {
                    tipoDenuncia = item.value.replace(/type::/g, '');
                }
            });

            if (catalogoEncontrado && tipoBanner == banner) {
                tipoDenuncia = capitalizeWords(tipoDenuncia);

                if (!reportMap[tipoDenuncia]) {
                    reportMap[tipoDenuncia] = 0;
                }

                reportMap[tipoDenuncia]++;
            }
        });

        return reportMap;
    };
    const reportMap = processDenuncias(dataTable, catalogo);
    return reportMap;
}

export const innovaMultiVerticalGeneral = (dataTable, catalogo) => {

    let banner = "innovasport"


    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }
    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }

    const reportMap = {};

    dataTable.data[0].data[2].forEach((subArray) => {
        let tipoCentro = "unknown";
        let tipoDenuncia = "unknown";
        let tipoBanner = "unknown";

        subArray.forEach((item) => {

            if (item.key === 'C::OWN::innline_2025') {


                tipoCentro = estados[item.value.replace(/type::/g, '').replace(/_/g, ' ').split('::')[3]]; //item.value.replace(/type::/g, '').replace(/_/g, ' ');
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
                tipoCentro = capitalizeWords(tipoCentro);



                // if (banner === tipoBanner) {
                //     tipoCentro = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[2];
                // } else {
                //     tipoCentro = "unknown";
                // }
            }

            if (item.key === 'C::OWN::tipo_de_reporte') {
                tipoDenuncia = item.value.replace(/type::/g, '');
                tipoDenuncia = item.value.split("::").pop();
                tipoDenuncia = capitalizeWords(tipoDenuncia);
                tipoDenuncia = tipoDenuncia.replace(/_/g, ' ')

            }
        });



        // if (tipoCentro !== "Undefined") {

        //     if (tipoCentro !== "unknown") {

        

        if (!reportMap[tipoCentro]) {
            reportMap[tipoCentro] = {};
        }

        if (!reportMap[tipoCentro][tipoDenuncia]) {
            reportMap[tipoCentro][tipoDenuncia] = 0;
        }
        reportMap[tipoCentro][tipoDenuncia]++;
        //     }

        // }
    });



    return reportMap;

}

export const innovaDistribution = (dataTable, catalogo, tipoGrafica) => {

    let banner = "innovasport"
    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }
    const reportMap = {};
    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }


    dataTable.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoDenuncia = "unknown";
        let tipoBanner = "unknown";

        subArray.forEach((item) => {

            if (item.key === catalogo) {

                estado = estados[item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[3]] // item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[2];
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
                estado = capitalizeWords(estado);
            }
            if (item.key === 'C::OWN::tipo_de_reporte') {
                tipoDenuncia = item.value.replace(/type::/g, '');
                tipoDenuncia = item.value.split("::").pop();
                tipoDenuncia = capitalizeWords(tipoDenuncia);
            }
        });


        if (tipoGrafica === "46") {
            if (estado === "Ciudad De Mexico") {
                if (estado !== "unknown") {
                    if (!reportMap[estado]) {
                        reportMap[estado] = {};
                    }

                    if (!reportMap[estado][tipoDenuncia]) {
                        reportMap[estado][tipoDenuncia] = 0;
                    }
                    reportMap[estado][tipoDenuncia]++;
                }
            }
        }
        else {
            if (estado !== "unknown") {
                if (!reportMap[estado]) {
                    reportMap[estado] = {};
                }

                if (!reportMap[estado][tipoDenuncia]) {
                    reportMap[estado][tipoDenuncia] = 0;
                }
                reportMap[estado][tipoDenuncia]++;
            }
        }

    });


    return reportMap;

}

export const innovaStacked = (dataTable, catalogo) => {
    const reportMap = {};

    let banner = "innovasport"
    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }

    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }


    dataTable.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoBanner = "unknown";
        let pathValue = "";

        const pathIndex = dataTable.data[0].data[5].findIndex((item, idx) => idx === dataTable.data[0].data[2].indexOf(subArray));
        if (pathIndex !== -1) {
            pathValue = dataTable.data[0].data[5][pathIndex].path || "";
        }

        subArray.forEach((item) => {
            if (item.key === catalogo) {

                estado = estados[item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[3]];
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
                estado = capitalizeWords(estado);
            }
        });


        const key = `${estado}|${pathValue}`;

        if (!reportMap[key]) {
            reportMap[key] = 0;
        }
        reportMap[key]++;

    });

    // const result = Object.entries(reportMap).map(([key, count]) => {
    //     const [estado, path] = key.split('|');
    //     return {
    //         estado: estado,
    //         path: path,
    //         count: count
    //     };
    // });


    const newDataValue = Object.entries(reportMap).map(([key, count]) => {
        const [estado, path] = key.split('|');

        return {
            category: estado,
            value: count,
            severity: [{ path }]
        };
    });



    const listita = newDataValue.filter(element => element.value !== 0);

    let listitaCompleta = [];

    listita.forEach(element => {
        let countLow = 0;
        let countMedium = 0;
        let countHigh = 0;

        element.severity.forEach(subelement => {
            switch (subelement.path) {
                case "type::low":
                    countLow += element.value;
                    break;
                case "type::medium":
                    countMedium += element.value;
                    break;
                case "type::hight":
                    countHigh += element.value;
                    break;
                default:
                    break;
            }
        });

        if (countLow === 0) countLow = undefined;
        if (countMedium === 0) countMedium = undefined;
        if (countHigh === 0) countHigh = undefined;

        if (countLow !== undefined || countMedium !== undefined || countHigh !== undefined) {
            listitaCompleta.push({
                state: element.category,
                low: countLow,
                medium: countMedium,
                high: countHigh,
            });
        }
    });


    const combinedResults = {};

    listitaCompleta.forEach(item => {
        const { state, low, medium, high } = item;

        if (!combinedResults[state]) {
            combinedResults[state] = {
                state,
                low: low || 0,
                medium: medium || 0,
                high: high || 0,
            };
        } else {
            if (low) combinedResults[state].low += low;
            if (medium) combinedResults[state].medium += medium;
            if (high) combinedResults[state].high += high;
        }
    });

    const finalResults = Object.values(combinedResults);

    listitaCompleta = finalResults

    return listitaCompleta;

}

export const innovaMexico = (dataTable, catalogo) => {
    const reportMap = {};

    let banner = "innovasport"
    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }

    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }


    dataTable.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoDenuncia = "unknown";
        let tipoBanner = "unknown";


        subArray.forEach((item) => {
            if (item.key === catalogo) {
                estado = estados[item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[3]];
                estado = capitalizeWords(estado);
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];

            }
            if (item.key === 'C::OWN::tipo_de_reporte') {
                tipoDenuncia = item.value.replace(/type::/g, '');
                tipoDenuncia = capitalizeWords(tipoDenuncia);
            }
        });


        const estadoKey = estado;

        if (estadoKey) {
            if (!reportMap[estadoKey]) {
                reportMap[estadoKey] = 0;
            }
            reportMap[estadoKey]++;

        }


    });
    return reportMap;
}
export const innovaMexicoZona = (dataTable, catalogo) => {
    let banner = "innovasport"
    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }

    const reportMap = {
        Norte: 0,
        Centro: 0,
        Sur: 0
    };

    const zonas = {
        norte: ["aguas calientes", "baja california", "baja california sur", "chihuahua", "coahuila", "durango", "nuevo leon", "sinaloa", "sonora", "tamaulipas", "zacatecas", "aguascalientes", "zona norte"],
        centro: ["ciudad de mexico", "estado de mexico", "guanajuato", "hidalgo", "jalisco", "michoacan", "queretaro", "san luis potosi", "nayarit", "HGO", "colima", "zona centro"],
        sur: ["campeche", "guerrero", "morelia", "puebla", "quintana roo", "tabasco", "veracruz", "yucatan", "oaxaca", "chiapas", "morelos", "zona sur"]
    };



    function capitalizeWords(str) {
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    dataTable.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoBanner = "unknown";

        subArray.forEach((item) => {
            if (item.key === catalogo) {

                estado = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::').pop();
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
            }
        });

        if (estado !== "unknown") {



            if (zonas.norte.includes(estado)) {
                reportMap.Norte++;
            } else if (zonas.centro.includes(estado)) {
                reportMap.Centro++;
            } else if (zonas.sur.includes(estado)) {
                reportMap.Sur++;
            } else {
                console.log("SIN ZONA::: " + estado);
            }




        }
    });

    return reportMap;
};

export const innovaSpecific = (dataTable, catalogo) => {
    let banner = "innovasport"
    if (dataTable.isInnova) {
        banner = dataTable.isInnova
    }

    function capitalizeWords(input) {
        // Verificar si el input es una cadena
        if (typeof input !== 'string') {
            // Si no es una cadena, intentar convertirlo a string
            try {
                input = String(input);
            } catch (e) {
                console.error("Error: No se pudo convertir el input a string");
                return ''; // Retornar cadena vacía en caso de error
            }
        }

        // Trim para eliminar espacios en blanco al inicio y al final
        input = input.trim();

        // Si la cadena está vacía después del trim, retornar cadena vacía
        if (input.length === 0) {
            return '';
        }

        // Capitalizar la primera letra de cada palabra
        return input.replace(/(?:^|\s)\S/gu, function (l) {
            return l.toUpperCase()
        });
    }

    let transformedMap = {};

    const reportMap = {};

    dataTable.data[0].data[2].forEach((subArray) => {
        let tipoCentro = "unknown";
        let tipoDenuncia = "unknown";
        let catalogo = "unknown";
        // let banner = "unknown";
        let tipoBanner = "unknown";


        subArray.forEach((item) => {
            // Filtra únicamente los centros de trabajo que contengan 'innovasport'


            if (item.key === 'C::OWN::innline_2025' && item.value && item.value.includes("innovasport")) {
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];
                tipoCentro = item.value.replace(/type::/g, '').replace(/_/g, ' ').split("::").pop();
                tipoCentro = capitalizeWords(tipoCentro); // Capitalizar adecuadamente el nombre
                // banner = tipoCentro.split(" ")[0];
                tipoCentro = tipoCentro.split(" ")[1];
            }

            if (["C::OWN::tipo_de_reporte"].includes(item.key) && item.value) {
                catalogo = item.key.replace("C::OWN::", ""); // Extrae el nombre del catálogo
                tipoDenuncia = capitalizeWords(item.value.replace(/type::/g, "").replace(/_/g, " "));
            }

            if (item.key === 'C::OWN::tipo_de_reporte') {
                tipoDenuncia = item.value.replace(/type::/g, '');
                tipoDenuncia = capitalizeWords(tipoDenuncia);
            }

        });




        // Solo agregar datos si tipoCentro es 'innovasport' y catalogo y tipoDenuncia no son desconocidos
        if (catalogo !== "unknown" && tipoDenuncia !== "unknown") {

            //if (tipoBanner !== "unknown") {

            // console.log(" Banner::: ("+tipoBanner+") |||  Centro::: ("+tipoCentro+") ||| Catalogo::: ("+catalogo+") ||| Denuncia::: ("+tipoDenuncia+") ");

            if (!reportMap[catalogo]) {
                reportMap[catalogo] = {};
            }

            if (!reportMap[catalogo][tipoDenuncia]) {
                reportMap[catalogo][tipoDenuncia] = 0;
            }

            reportMap[catalogo][tipoDenuncia]++;

            //}
        }

    });

    console.log("::: REPORT MAP");
    console.log(reportMap);


    for (const key in reportMap.tipo_de_reporte) {
        const value = reportMap.tipo_de_reporte[key];

        // Divide las claves que contienen "::"
        const [generalCategory, subCategory] = key.split("::");

        if (!transformedMap[generalCategory]) {
            transformedMap[generalCategory] = {};
        }

        transformedMap[generalCategory][subCategory || ""] = value;
    }

    // // Agregar totales por categoría al transformedMap
    // for (const generalCategory in transformedMap) {
    //     let total = 0;

    //     // Sumar valores de todas las subcategorías
    //     for (const subCategory in transformedMap[generalCategory]) {
    //         total += transformedMap[generalCategory][subCategory];
    //     }

    //     // Agregar el total al inicio con el mismo nombre de la categoría
    //     transformedMap[generalCategory][generalCategory] = total;
    // }

    console.log(">>> Total");
    console.log(transformedMap);


    return transformedMap;
}